import React, { ReactElement } from 'react';

import { PublicPage } from 'api/website';
import { Box } from 'components/Box';
import { StaffTools } from 'components/Staff/StaffTools';
import { useCurrentUserIsStaff } from 'store/main/hooks';
import { gutterWidth } from 'theme';

type Props = {
  content: PublicPage;
};

export function LayoutStaffTools({ content }: Props): ReactElement | null {
  const isStaff = useCurrentUserIsStaff();
  if (!isStaff) return null;

  return (
    <Box
      position="absolute"
      top="100%"
      right={gutterWidth / 2}
      mt={[gutterWidth / 2, null, null, gutterWidth + 18]}
    >
      <StaffTools content={content} />
    </Box>
  );
}
